import React, { FC, ReactNode } from 'react';
import { Experiment } from '../../types';
import ExperimentContext from './ExperimentContext';

type Props = {
  children: ReactNode;
  values?: Experiment[];
};

const ExperimentProvider: FC<Props> = ({ children, values }) => (
  <ExperimentContext.Provider value={{ experiments: values || [] }}>
    {children}
  </ExperimentContext.Provider>
);

export default ExperimentProvider;
